import { getInstanceID } from 'helpers/getRootNode';
import localStorageManager from 'helpers/localStorageManager';

const colorSetters = {
  'SET_CELL_BACKGROUND_COLORS': 'cellBackgroundColors',
  'SET_TEXT_COLORS': 'textColors',
  'SET_BORDER_COLORS': 'borderColors',
};

const customColorSetters = {
  'SET_CUSTOM_CELL_BACKGROUND_COLORS': 'customCellBackgroundColors',
  'SET_CUSTOM_TEXT_COLORS': 'customTextColors',
  'SET_CUSTOM_BORDER_COLORS': 'customBorderColors',
};

export default (initialState) => (state = initialState, action) => {
  const { type, payload } = action;

  if (type in colorSetters) {
    return {
      ...state,
      [colorSetters[type]]: [...payload.colors],
    };
  }

  if (type in customColorSetters) {
    if (localStorageManager.isLocalStorageEnabled()) {
      const instanceId = getInstanceID();
      localStorageManager.setItemSynchronous(`${instanceId}-${customColorSetters[type]}`, JSON.stringify(payload.customColors));
    } else {
      console.error(`localStorage is disabled, ${customColorSetters[type]} cannot be restored`);
    }
    return {
      ...state,
      [customColorSetters[type]]: [...payload.customColors],
    };
  }

  switch (type) {
    case 'SET_ACTIVE_CELL_RANGE': {
      const { activeCellRange, cellProperties } = payload;
      return {
        ...state,
        activeCellRange,
        cellProperties: {
          ...cellProperties
        }
      };
    }
    case 'SET_SPREADSHEET_EDITOR_EDIT_MODE':
      return {
        ...state,
        editMode: payload.mode,
      };
    case 'SET_ACTIVE_CELL_RANGE_STYLE': {
      const { styles } = payload;
      return {
        ...state,
        cellProperties: {
          ...state.cellProperties,
          styles: {
            ...state.cellProperties.styles,
            ...styles,
            font: {
              ...state.cellProperties.styles.font,
              ...(styles.font || {}),
            },
          },
        },
      };
    }
    case 'SET_SELECTED_BORDER_COLOR_OPTION': {
      const { selectedBorderColorOption } = payload;
      return {
        ...state,
        selectedBorderColorOption,
      };
    }
    case 'SET_SELECTED_BORDER_STYLE_OPTION': {
      const { selectedBorderStyleListOption } = payload;
      return {
        ...state,
        selectedBorderStyleListOption,
      };
    }
    case 'SET_SPREADSHEET_EDITOR_CAN_UNDO': {
      const { canUndo } = payload;
      return {
        ...state,
        canUndo,
      };
    }
    case 'SET_SPREADSHEET_EDITOR_CAN_REDO': {
      const { canRedo } = payload;
      return {
        ...state,
        canRedo,
      };
    }
    case 'SET_ACTIVE_BORDER_BUTTONS': {
      const { activeBorderButtons } = payload;
      return {
        ...state,
        activeBorderButtons,
      };
    }
    default:
      return state;
  }
};
